<template>
  <modal :show="visible" @close="visible = false" modalClasses="modal-xxl">
    <div slot="header">
      <h3>Lịch sử tồn kho</h3>
    </div>
    <block ref="bmdal" style="min-height: 350px; overflow-y: auto;">
      <div v-if="productInfo.product && productInfo.spec" class="legend mb-2">
        <div class="title">
          Thông tin sản phẩm
        </div>
        <div class="row">
          <div class="col-6">
            <ul>
              <li>
                Tên sản phẩm: <b>{{ productInfo.product.name }}</b>
              </li>
              <li>
                Mã sản phẩm: <b>{{ productInfo.product.code }}</b>
              </li>
              <li>
                Quy cách: <b>{{ productInfo.spec.name }}</b> mm
              </li>
              <li>
                Hệ màu: <b>{{ productInfo.color.label }}</b>
              </li>
            </ul>
          </div>
          <div class="col-6">
            <ul>
              <li>
                Mã màu 1: <b>{{ productInfo.colorCode1 }}</b>
              </li>
              <li>
                Mã màu 2: <b>{{ productInfo.colorCode2 }}</b>
              </li>
              <li>
                Độ dài: <b>{{ productInfo.length }}</b> cm
              </li>
              <li>Vị trí lưu kho: <span v-html="productInfo.position"></span></li>
            </ul>
          </div>
        </div>
      </div>
      <soft-table
        class="table align-items-center table-flush"
        tbody-classes="list"
        :pending="false"
        :dataTable="tableData"
        :fields="fields"
        :minHeight="$hMainContent - 164"
        :noDelete="true"
        ref="soft-table"
      >
        <template v-slot:cell(userCreate)="{ value }">
          <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
        </template>
        <template v-slot:cell(note)="{ value }">
          <div v-html="value"></div>
        </template>
        <template v-slot:cell(position)="{ value }">
          <div v-html="value"></div>
        </template>
        <template v-slot:cell(quantityIn)="{ item }">
          <span v-if="item.type == 'IN'">
            {{ $formatNumber(item.quantity) }}
            <span style="color:green; font-style: italic">({{ $formatNumber(item.quantityVerify) }})</span>
          </span>
        </template>
        <template v-slot:cell(reason)="{ item }">
          <div v-if="item.isAuto == true">
            <span v-if="item.type == 'IN'">Nhập chuyển tự động : {{ item.code }}</span>
            <span v-if="item.type == 'OUT'">Xuất chuyển tự động : {{ item.code }}</span>
          </div>
          <div v-else>
            <span v-if="item.type == 'IN'"> Nhập kho lệnh chế tạo : {{ item.manufacture.code }} </span>
            <span v-if="item.type == 'OUT'"> Xuất kho ĐH : {{ item.order.code }} </span>
          </div>
        </template>
        <template v-slot:cell(quantityOut)="{ item }">
          <span v-if="item.type == 'OUT'">
            {{ $formatNumber(item.quantity) }}
          </span>
        </template>
        <template>
          <pagination
            class="mt-2 mb-2 mr-2"
            slot="footer"
            :total="listQuery.total"
            :perPage="listQuery.limit"
            @change="pagChange"
          />
        </template>
      </soft-table>
    </block>
  </modal>
</template>
<script>
import { productService } from '@/_services';

export default {
  props: {},
  components: {},
  data() {
    return {
      visible: false,
      productInfo: {
        id: 0,
        color: {},
        productSpecify: {},
        unit: '',
        product: {},
        colorCode1: '',
        colorCode2: '',
        colorText: '',
        length: 0,
        quota: 0,
        quantity: 0,
        totalKgWrap: 0,
        position: '',
        description: ''
      },
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        search: ''
      },
      tableData: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          key: 'dateCreated',
          label: 'Ngày tháng',
          class: 'col-fix text-center',
          sortable: true
        },
        {
          key: 'quantityIn',
          label: 'Nhập',
          class: 'col-fix  text-center',
          sortable: true
        },
        {
          key: 'quantityOut',
          label: 'Xuất',
          class: 'col-fix text-center'
        },
        {
          key: 'reason',
          label: 'Nguyên nhân'
        },
        {
          key: 'note',
          label: 'Ghi chú'
        },
        {
          key: 'position',
          label: 'Vị trí lưu'
        },
        {
          key: 'quantityOld',
          label: 'Tồn Cũ',
          class: 'col-fix text-center'
        },
        {
          key: 'quantityNew',
          label: 'Tồn Mới',
          class: 'col-fix text-center'
        }
      ]
    };
  },
  methods: {
    setData(productInfo) {
      this.productInfo = productInfo;
      this.getData();
    },
    getData() {
      productService.findAllHistoryProductInfo(this.productInfo.id, this.listQuery).then(res => {
        this.tableData = res.data.data;
        this.listQuery.total = res.data.total;
      });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
